import { ApplyButton } from 'components/ApplyButton/ApplyButton';
import { SaveButton } from 'components/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown';
import { OrgType } from 'utils/constants/general/orgTypes';

import { ListingViewActionButtonsHolder } from './ListingViewActionButtons.styled';

type Props = {
  hasAts: boolean;
  listingId: string;
  listingName: string;
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
  listingUrl: Record<string, string>;
  orgId?: string;
  orgName?: string;
  orgType?: OrgType;
  mobile: boolean;
  isPreview?: boolean;
  hasRsvp?: boolean;
};

export function ListingViewActionButtons({
  hasAts,
  hasRsvp,
  listingId,
  listingName,
  listingType,
  listingUrl,
  orgId,
  orgType,
  orgName,
  mobile,
  isPreview = false,
}: Props) {
  const content = (
    <ListingViewActionButtonsHolder>
      <ApplyButton
        atsIsEnabled={hasAts}
        hasRsvp={hasRsvp}
        listingId={listingId}
        listingType={listingType}
        mobile={mobile}
        size="medium"
      />
      <SaveButton
        listingId={listingId}
        listingType={listingType}
        listingName={listingName}
        orgId={orgId}
        orgName={orgName}
        orgType={orgType}
      />
      {!mobile && (
        <ShareListingButton
          disabled={!listingUrl}
          listingId={listingId}
          listingType={listingType}
          listingUrl={listingUrl}
        />
      )}
      <ListingActionsDropdown
        listingId={listingId}
        listingType={listingType}
        listingUrl={listingUrl}
        orgId={orgId}
        orgName={orgName}
        orgType={orgType}
      />
    </ListingViewActionButtonsHolder>
  );

  if (!isPreview) return content;

  return (
    <Tooltip
      content={getText("You can't take these actions in Preview Mode")}
      triggerCondition
      variant="filled"
      placement={mobile ? 'top-center' : 'bottom-center'}
      size="large"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: isPreview ? 'not-allowed' : undefined,
        }}
      >
        <div style={isPreview ? { pointerEvents: 'none' } : undefined}>
          {content}
        </div>
      </div>
    </Tooltip>
  );
}
